import React from "react";
import { Typography } from "@mui/material";

const NotificationsSettings = () => {
  return (
    <>
      <Typography variant="h5">Notifications Settings</Typography>
      {/* ...existing form or content for notifications settings... */}
      <Typography>Set your notification preferences here.</Typography>
    </>
  );
};

export default NotificationsSettings;
